<template>
    <div class="componentsEdit">
        <div :class="showEdit ? 'move item' : 'item'">
            <div class="mk_hover" :class="{ 'showPage': !showEdit }">
                <div class="floorEdit" v-if="showEdit">
                    <div class="delete" @click="floorDelete(index)">删除</div>
                    <div class="edit" @click="selectChart()">组件选择</div>
                </div>
                <div class="mask_container enabled relative" style="width: 300px;height: 400px;">
                    <div :class="{
                        mask_layer: true,
                        show: !showEdit
                    }">
                        <div class="edit_tag">
                            <div class="edit_tag_one" @click="selectIndex(0)">组件配置</div>
                        </div>
                    </div>
                    <div style="width: 300px;height: 400px;">
                        <CanvasContent :index="index" name="char">
                        </CanvasContent>
                    </div>
                </div>

                <!-- <component :is='element.value' @operate='operate' @save='saveData' :index='index' :data="element" class="mar_b_14" :key='element.key'>
                </component> -->

            </div>
        </div>
        <!-- 选择图表 -->
        <el-dialog v-model="chartVisible" title="模块配置" width="500">
            <el-form :model="addChartForm">
                <el-form-item label="组件选择">
                    <el-select v-model="addChartForm.type" placeholder="请选择组件类型" style="width: 240px">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="图表选择">
                    <el-radio-group v-model="addChartForm.radio">
                        <div class="radio-content" v-for="option in options" :key="option.label">
                            <div class="chartImg">
                                <img src="../../../../images/bzmb.png" alt="">
                            </div>
                            <div class="chartFont">{{ option.label }}</div>
                            <el-radio :label="option.label">
                                <span class="radio-custom-content"></span>
                            </el-radio>
                        </div>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveModule()">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance, defineProps } from 'vue'
import { chartsArray } from '../../../../enums/charts.js'
import CanvasContent from "../../../../components/CanvasPage/CanvasContent";
import { useStore } from 'vuex';
const props = defineProps({
    index: {
        type: Number,
        default: 0,
    },
});
const index = ref(props.index)
const store = useStore();
const chartDatas = ref(computed(() => store.state.chartData));
const showEdit = ref(true)
const chartVisible = ref(false)
const project = ref(computed(() => store.state.project));
const selectProject = (projectShow) => {
    project.value.projectShow = projectShow
    store.commit("setProject", project.value);
}
const selectIndex = (index) => {
    project.value.index = index
    selectProject(false)
}
const selectChart = (e) => {
    chartVisible.value = true
}
const addChartForm = ref({
    type: '',
    radio: ''
})
const options = ref(chartsArray)
const radio = ref('')
const saveModule = () => {
    chartVisible.value = false
    let j = chartDatas.value.componentList.find(item => item.config.baseConfig.type == addChartForm.value.type)
    chartDatas.value.componentList[index.value] = JSON.parse(JSON.stringify(j))
    console.log(chartDatas.value.componentList[0],'变化')
    store.commit("setChartData", chartDatas.value);
}
</script>

<style lang="less" scoped>
.componentsEdit {
    position: relative;
    padding-bottom: 30px;
    padding-top: 50px;

    .mk_hover {
        position: relative;
        width: 100%;

        .floorEdit {
            display: none;
            position: absolute;
            margin-top: -30px;
            width: 100%;
            height: 30px;
            cursor: auto;
        }

        .edit {
            position: absolute;
            right: 20px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #296bdd;
            color: #fff;
            cursor: pointer;
            border: #296bdd 1px solid;
        }

        .delete {
            position: absolute;
            right: 150px;
            width: 100px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #fff;
            color: #296bdd;
            cursor: pointer;
            border: #296bdd 1px solid;
            border-bottom: none;
        }
    }

    .mk_hover:before {
        content: "";
        display: none;
        position: absolute;
        z-index: 14;
        top: 0px;
        right: 0px;
        left: 0px;
        border-top: solid #296bdd 1px;
        background: rgba(78, 140, 251, .2);
    }

    .move {
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
    }

    .radio-content {
        text-align: center;
        margin-right: 20px;

        .chartImg {
            width: 100px;
            height: 50px;

            img {
                width: 100px;
                height: 50px;
            }
        }

        .radio-custom-content {
            margin-left: 10px;
        }

        .chartFont {
            font-size: 14px;
        }

        ::v-deep .el-radio {
            width: 16px;
            height: 16px;
            line-height: 16px;
        }
    }


}

.mk_hover:hover:before {
    display: block;
}

.mk_hover:hover {
    width: 100%;
    margin: 0 auto;

    .floorEdit {
        display: block;
    }
}

.showPage:hover:before {
    border: none;
}

.showPage:hover {
    .floorEdit {
        display: none;
    }
}

/* 编辑区域css */
.relative {
    position: relative;
}

.mask_container {
    /* z-index: 40 */
    width: 100%;
}

.mask_container.enabled:hover .mask_layer {
    display: block;
}

.mask_container .show {
    display: none !important;
}

.mask_container .mask_layer {
    display: none;
    position: absolute;
    /* z-index: 10; */
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: dotted 1px #296bdd;
    background: rgba(78, 140, 251, .2);
    cursor: pointer;
}

.mask_container .mask_layer .edit_tag {
    position: absolute;
    z-index: 1;
    top: 5px;
    right: 5px;
}

.mask_container .mask_layer .edit_tag .edit_tag_one {
    padding: 3px 8px;
    border-radius: 3px;
    background: #296bdd;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
}

.mask_container .mask_layer .edit_tag .edit_tag_one_del {
    padding: 3px 8px;
    border: 1px solid #296bdd;
    border-radius: 3px;
    background: #fff;
    color: #296bdd;
    font-size: 12px;
    line-height: 16px;
}

.mask_container .mask_layer_type {
    background: transparent;
}
</style>